import ModalBackdrop from "./Backdrop";

export function PopupButton(props) {
  return (
    <button
      style={{
        color: "#414141",
        padding: "10px",
        width: "auto",
        ...(props.style || {}),
      }}
      onClick={props.onClick}
    >
      {props.children}
    </button>
  );
}

function PopupModal(props) {
  return (
    <ModalBackdrop open={props.open}>
      <div className="lp-popup-body">
        <h5 className={props.heading}>{props.heading}</h5>
        <p>{props.message}</p>
        <div className="buttons">{props.children}</div>
      </div>
    </ModalBackdrop>
  );
}

export default PopupModal;
